/*
 * Panorama Studios
 */
$(function () {
	// https://stackoverflow.com/questions/28087877/testing-of-css-mix-blend-mode/28088291#28088291
	Modernizr.addTest('mixblendmode', function () {
		return Modernizr.testProp('mixBlendMode');
	});
	if (!Modernizr.mixblendmode) {
		$(document.body).addClass('no-background-blend-mode');
	}

	// Responsive menu
	$('header').each(function () {
		var element = $(this),
			body = $(document.body),
			responsiveNav = $('.responsive-nav');

		var toggler = $('<div class="toggler toggler--closed"><span>Menu</span></div>').click(function () {
			body.toggleClass('open');
			responsiveNav.toggleClass('collapsed');
			toggler.toggleClass('toggler--closed');
		}).appendTo(element);

		responsiveNav.find('nav > ul > li').each(function () {
			var element = $(this);
			var link = element.children('a').first();
			link.click(function (e) {
				responsiveNav.toggleClass('collapsed');
				toggler.toggleClass('toggler--closed');
			});
		});
	});

	// Open language on touch
	$('.languages').each(function () {
		var element = $(this);

		element.on("touchend", function (e) {
			element.toggleClass('open');
		});
	});

	// Change scrollTo default
	var headerHeight = $('header').outerHeight();
	$.extend($.scrollTo.defaults, {
		axis: 'y',
		interrupt: true,
		duration: 400,
		offset: {
			top: -headerHeight
		}
	});

	// Navigation links
	var links = $('header a[data-id]');
	if (links.closest('.active').length == 0 || links.parents('.active.child').length || location.search == '?static') {
		// Update document without dynamic content
		$(document).trigger('update');
	} else {
		// Dynamic pages are always front pages :-)
		$(document.body).addClass('frontpage');

		// Load dynamic content
		$('#container').dynamicContent({
			links: links,
			elementAttributes: {
				'class': 'dynamic-content'
			},
			isActive: function (link) {
				return $(link).hasClass('active') || $(link).parents('.active').length;
			},
			onLoad: function () {
				// Add loader
				this.element.addClass('loading');
			},
			onComplete: function (elements, titles, activeIndex) {
				// Remove all slogans
				elements.find('h2.slogan').remove();

				// Remove all H1's'
				elements.find('h1.center').remove();

				// Remove loader
				this.element.removeClass('loading');

				// Update document
				$(document).trigger('update');

				// Add scrollTo to all links
				this.links.each(function (i, link) {
					var element = elements.get(i);

					$(document.links).filter(function () {
						// Find links with the same href
						return this.href === link.href;
					}).click(function (e) {
						// Scroll to element
						$.scrollTo(element);
						e.preventDefault();
					});

					// Add waypoint tracking
					new Waypoint.Focus({
						element: element,
						offset: headerHeight,
						handler: function () {
							// Update navigation
							this.links.parent('li').removeClass('active');
							$(link).parent('li').addClass('active');

							// Change URL to match filters
							if (window.history) {
								history.replaceState(null, titles[i], link.href);
							}

							// Change document title
							document.title = titles[i];
						}.bind(this)
					});
				}.bind(this));

				//elements.last().css('min-height', function () {
				//    return $(window).height() - headerHeight;
				//});

				// Scroll to active
				if (activeIndex !== null) {
					$.scrollTo(elements[activeIndex]);
				}
			}
		});
	}
});

$(document).on('update', function () {
	// Slideshows
	$('.slideshow').each(function () {
		var element = $(this);
		if (element.children('li').length > 1) {
			element.lightSlider({
				item: 1,
				slideMargin: 0,
				addClass: element.attr('class'),
				mode: 'fade',
				speed: 1000,
				auto: true,
				loop: true,
				pause: 7000,
				controls: false,
				pager: true
			});
		}
	});

	// Facts slideshow
	$('.facts').each(function () {
		var element = $(this);
		if (element.children('div').length > 1) {
			element.lightSlider({
				item: 1,
				slideMargin: 0,
				addClass: element.attr('class'),
				mode: 'fade',
				speed: 1000,
				auto: true,
				loop: true,
				pause: 5000,
				controls: false,
				pager: false
			});
		}
	});

	$('.recipes .slider').each(function () {
		var element = $(this);
		var cssClass = element.attr('class');

		element.lightSlider({
			slideMargin: 0,
			loop: true,
			auto: true,
			speed: 1000,
			pause: 3500,
			pager: false,
			addClass: cssClass,
			item: 4,
			responsive: [
				{
					breakpoint: 1280,
					settings: {
						item: 3
					}
				},
				{
					breakpoint: 1024,
					settings: {
						item: 2
					}
				},
				{
					breakpoint: 640,
					settings: {
						item: 1
					}
				}
			],
			onSliderLoad: function (el) {
				var maxHeight = Math.max.apply(Math, el.children().map(function () {
					return $(this).outerHeight();
				}));
				el.css('height', maxHeight);
			}
		});
	});

	// Lightbox
	$('#container').lightGallery({
		selector: '[rel=lightbox]',
		download: false
	});

	// Smooth scroll
	$('a[href*=\\#]').click(function () {
		var target = $(this.hash);

		if (!target.length) {
			target = $('[name=' + this.hash.slice(1) + ']');
		}

		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top
			}, 500);

			return false;
		}
	});

	// Change target for external sites
	var getDomainName = function (hostName) {
		return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
	};
	$('a:not([target])').filter(function () {
		var link = $(this);

		if (link.filter('[rel~="external"]').length) return true; // Link rel attribute contains 'external'

		var href = link.attr('href');
		if (new RegExp('\.pdf$', 'i').test(href)) return true; // Link to PDF file

		if (new RegExp('^https?://', 'i').test(href)) {
			var linkHostName = getDomainName(href.substring(href.indexOf('/') + 2, href.indexOf('/', 8)));
			if (!new RegExp('(^|\.)' + getDomainName(document.location.hostname) + '$', 'i').test(linkHostName)) {
				// Link is to different domain name
				return true;
			}
		}

		return false;
	}).attr('target', '_blank');
})